import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_combune_category_blog_api = async (
  source_slug,
  feature_slug,
  page = 0,
  limit = 50
) => {
  const requestObj = {
    path: `api/category/combined_data/${source_slug}/${feature_slug}?page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

// Separate API for slider blogs
export const get_slider_blogs_api = async (
  source_slug,
  feature_slug,
  page = 0,
  limit = 50
) => {
  const requestObj = {
    path: `api/category/combined_data/slider_blogs/${feature_slug}/${source_slug}?page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

// Separate API for categories
export const get_categories_api = async (
  source_slug,
  feature_slug,
  page = 0,
  limit = 50
) => {
  const requestObj = {
    path: `api/category/combined_data/categories/${feature_slug}/${source_slug}?page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const comine_blogs_api = async (
  category_slug,
  search,
  source_slug,
  feature_slug
) => {
  const requestObj = {
    path: `api/blog/get_blog_by_category_slug/${category_slug}?search=${search}&source_slug=${
      source_slug || ""
    }&feature_slug=${feature_slug || ""}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
